export const WHATSAPP_NUMBER = "918341717181";
export const PHONE_DISPLAY = "+91 8341717181";
export const EMAIL = "rvsarmoor@gmail.com";
export const ADDRESS = "Shop No. 11, RTC Busstand, Armoor, Nizamabad, Telangana – 503224";

export const waLink = (message = "Hello RVS Electronics, I have an inquiry") =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const openWhatsApp = (message) => {
    window.open(waLink(message), "_blank", "noopener,noreferrer");
};
